/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import MaskedFormControl from "../../../../../monitoring/src/Components/Common/MaskedInputControl";
import React from "react";

export class ZipCodeFieldEditor extends BaseFieldEditor {
	@autobind
	_render() {
		return <MaskedFormControl
			mask='11111'
			type="text"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		/>;
	}
}